import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorWalletCards = (
  cards: cardApiSpec.Card[]
): cardApiSpec.Card[] => cards.filter(card => card.status !== "Closed");
